export const PAGE_NOT_FOUND = 404

export const ELIGIBILITY_ERRORS = {
  EXPIRED: 'ShopperNotEligibleVerificationExpiredValidationException',
  MISSING_USERGROUP: 'ShopperNotEligibleMissingUserGroupValidationException',
}
